<template>
  <t-default-layout active-nav-id="news-and-seminars">
    <div :class="componentClassName">
      <a-back-page text="一覧画面" page="NewsAndSeminars" :show="show" />
      <form
        ref="form"
        class="t-news-and-seminars-detail__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-news-and-seminars-detail__fields">
          <m-section>
            <m-action-card
              :id="idName[1]"
              test-id-text="detail-news-and-seminar"
              title="詳細設定"
              :document-id="id"
              header-border
              no-header-margin
              icon="clock"
            >
              <div class="t-news-and-seminars-detail__fields">
                <div class="t-news-and-seminars-detail__row">
                  <m-form-input id="t-news-and-seminars-detail-importantFlag__form-input">
                    <a-text id="t-news-and-seminars-detail-importantFlag__a-text">優先</a-text>　　
                    <a-switch
                      id="t-news-and-seminars-detail-importantFlag"
                      v-model="newsAndSeminarData.importantFlag"
                      data-testid="detail-news-and-seminar-priority-display"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <o-transition-type-selector
                  v-if="updatedDataFlag"
                  v-model:transition-type="newsAndSeminarData.transitionType"
                  v-model:transition-doc="newsAndSeminarData.transitionDoc"
                  v-model:contents-url="newsAndSeminarData.contentsURL"
                  disabled="true"
                />
                <div id="t-news-and-seminars-detail-radio" class="t-news-and-seminars-detail__row">
                  <m-form-input>
                    <m-news-and-seminar
                      id="radio-news"
                      v-model="newsAndSeminarData.type"
                      data-testid="detail-news-and-seminar-display-news"
                      name="flag"
                      value="news"
                      label="ニュース"
                      :disabled="true"
                    />
                    <m-news-and-seminar
                      id="radio-seminar"
                      v-model="newsAndSeminarData.type"
                      data-testid="detail-news-and-seminar-display-seminar"
                      name="flag"
                      value="seminar"
                      label="セミナー"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <div id="t-news-and-seminars-detail-uploading-file" class="t-news-and-seminars-detail__row">
                  <div class="t-news-and-seminars-detail__col-1">
                    <div class="t-news-and-seminars-detail__fields">
                      <m-form-input>
                        <a-upload-field
                          id="t-news-and-seminars-detail-upload-image"
                          v-model="newsAndSeminarData.imageFile.file"
                          test-id-text="detail-news-and-seminar-image"
                          name="imageFile"
                          class="t-news-and-seminars-detail-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          :disabled="true"
                          @change="handleUploadFileChange('imageFile', newsAndSeminarData.imageFile.file)"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-news-and-seminars-detail__col-2">
                    <div class="t-news-and-seminars-detail__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="title"
                          v-model="newsAndSeminarData.title"
                          data-testid="detail-news-and-seminar-title-display"
                          type="text"
                          maxlength="30"
                          maxlength-id="detail-news-and-seminar-title-maxlength"
                          placeholder="タイトル入力"
                          :disabled="true"
                        />
                      </m-form-input>
                    </div>
                  </div>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-news-and-seminars-detail__fields">
                <div id="t-news-and-seminars-detail-cast-start-date-day__row" class="t-news-and-seminars-detail__row">
                  <a-text id="t-news-and-seminars-detail-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-news-and-seminars-detail-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="newsAndSeminarData.castStartDate"
                      test-id-text="detail-news-and-seminar-publish-start"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <div class="t-news-and-seminars-detail__row">
                  <a-text id="t-news-and-seminars-detail-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-news-and-seminars-detail-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="newsAndSeminarData.castEndDate"
                      test-id-text="detail-news-and-seminar-publish-end"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-news-and-seminars-detail__fields__pushtype">
                <m-form-input id="t-news-and-seminars-detail__fields__pushtype">
                  <a-select-field
                    id="t-news-and-seminar-detail__fields__pushtype__a-select-field"
                    v-model="newsAndSeminarData.checkStatus"
                    data-testid="detail-news-and-seminar-check-status-select"
                    :options="checkStatusOptions"
                    disabled="true"
                  />
                </m-form-input>
              </div>
              <!-- 情報を表示するために m-data-table を追加します 承認フロー -->
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="newsAndSeminarData.checkHistories"
                id-text="news-and-seminar-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <div id="t-news-and-seminars-detail-buttons">
          <div v-show="!isPublished" class="t-news-and-seminars-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-news-and-seminars-detail-detail-saveBtn"
                data-testid="detail-news-and-seminar-edit-button"
                variant="block"
                color="primary"
                :disabled="isEnded || disableButton"
                @click="handleNavigateEdit"
                >編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-news-and-seminars-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-news-and-seminars-detail-edit-return-unpublished-btn"
                data-testid="detail-news-and-seminar-edit-return-unpublished-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleEditReturnUnpublished"
                >未公開に戻す</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-news-and-seminars-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-news-and-seminars-detail-edit-keep-published-btn"
                data-testid="detail-news-and-seminar-edit-keep-published-button"
                variant="block"
                color="primary"
                :disabled="disabledButton || disableButton"
                @click.stop="handleEditKeepPublished"
                >公開のまま編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div class="t-news-and-seminars-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-news-and-seminars-detail-detail-deleteBtn"
                data-testid="detail-news-and-seminar-delete-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleConfirmDelete"
                >削除</a-button
              >
            </m-form-action-buttons>
          </div>
        </div>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="news-and-seminarsCreate_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="news-and-seminarsCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="t-news-and-seminars-remove-modal-close-button"
            data-testid="detail-news-and-seminar-modal-cancel-button"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button
            id="t-news-and-seminars-delete-button"
            data-testid="detail-news-and-seminar-modal-confirm-button"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="handleDelete"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import MNewsAndSeminar from '@/components/molecules/news-and-seminar-radio';
import OTransitionTypeSelector from '@/components/organisms/transition-type-selector';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';

export default {
  name: 't-news-and-seminars-detail',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    ASwitch,
    AUploadField,
    ACalendarField,
    MNewsAndSeminar,
    AApplyTextField,
    OTransitionTypeSelector,
  },
  mixins: [customRequest, customValidate, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      show: this.$route.query.show ?? '1',
      idName: [],
      disableButton: false,
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      disabledButton: null,
      isPublished: false, //公開中かどうかのフラグ
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      //おすすめの記事・セミナーデータ
      newsAndSeminarData: {
        title: '', //おすすめの記事・セミナータイトル
        imageURL: '', //画像の公開URL
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        importantFlag: false, //優先フラグ
        castStartDate: '', //公開開始日
        castEndDate: '', //公開終了日
        draftFlag: false, //下書き
        checkStatus: '', //チェックステータス
        contentsURL: '', //URL
        type: '', //タイプ
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
        transitionType: 'url', //遷移先種別
        transitionDoc: '', //遷移先ドキュメントID
      },
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
      isEnded: false,
      nowDate: '',
      updatedDataFlag: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-news-and-seminars-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    this.handleGetNewsAndSeminarInfo(() => {
      const userRole = this.$store.state.user.authInfo;
      const checkStatus = this.newsAndSeminarData.checkStatus;
      if (userRole === 'writer' && checkStatus !== 'draft') {
        this.disableButton = true;
      }
    });
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-news-and-seminars-detail-' + i;
    }
  },
  mounted() {},
  methods: {
    handleGetNewsAndSeminarInfo(callback) {
      const id = this.$route.query.id || this.id;
      this.nowDate = utils.currentDateTime();
      if (id) {
        this.postRequest('/news-and-seminars/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data) {
              const data = e.data;
              this.newsAndSeminarData.title = data?.title || '';
              this.newsAndSeminarData.imageURL = data?.imageURL || '';
              (this.newsAndSeminarData.imageFile = {
                file: e.data.imageURL ? e.data.imageURL : null,
              }),
                (this.newsAndSeminarData.importantFlag = data?.importantFlag || false);
              this.newsAndSeminarData.castStartDate = data?.castStartDate || '';
              this.newsAndSeminarData.castEndDate = data?.castEndDate || '';
              this.newsAndSeminarData.draftFlag = data?.draftFlag || false;
              this.newsAndSeminarData.contentsURL = decodeURI(data?.contentsURL) || '';
              this.newsAndSeminarData.type = data?.type || '';
              this.newsAndSeminarData.checkStatus = data?.checkStatus || '';
              this.newsAndSeminarData.checkHistories = data?.checkHistories || [];
              this.newsAndSeminarData.transitionType = data?.transitionType || 'url';
              this.newsAndSeminarData.transitionDoc = data?.transitionDoc || '';
              // 下書きとチェク済み中ではなく、公開終了日時を過ぎている場合、isEndedフラグをtrueにする
              if (this.newsAndSeminarData.checkStatus === 'approved') {
                if (this.newsAndSeminarData.castEndDate && this.newsAndSeminarData.castEndDate < this.nowDate) {
                  this.isEnded = true;
                }
              }
              const nowDate = utils.currentDateTime();
              // 公開中の投稿か確認
              if (
                data &&
                data.checkStatus === 'approved' &&
                data.castStartDate &&
                data.castEndDate &&
                data.castStartDate <= nowDate &&
                nowDate <= data.castEndDate
              ) {
                this.isPublished = true;
              }
            } else {
              this.showErrorModal(messageContent.requireTry('おすすめの記事・セミナー取得'));
            }
            if (typeof callback === 'function') {
              callback();
            }
            this.updatedDataFlag = true;
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('ニュース・セミナー取得'));
          });
      }
    },
    async handleEditReturnUnpublished() {
      const data = {
        id: this.$route.query.id,
      };
      await this.postRequest('/news-and-seminars/edit-return-unpublished', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'NewsAndSeminars' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('ニュース・セミナー更新'));
          }
        }
      });
    },
    async handleEditKeepPublished() {
      const data = {
        id: this.$route.query.id,
      };

      this.disabledButton = 'disabled';

      await this.postRequest('/news-and-seminars/edit-keep-published', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'NewsAndSeminars' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('ニュース・セミナー更新'));
          }
        }
        this.disabledButton = null;
      });
    },
    handleNavigateEdit() {
      const id = this.$route.query.id;
      if (id) {
        this.$router.push({ name: 'NewsAndSeminarsEdit', query: { id: id, source: 'detail', show: this.show } });
      }
    },
    handleConfirmDelete() {
      this.resultModalVisible = true;
      this.resultModalTitle = 'Info';
      this.resultModalContent = messageContent.confirmDelete(this.newsAndSeminarData.title);
    },
    handleDelete() {
      this.handleCloseModal();
      const data = {
        execUserID: this.$store.state.user.userID,
        documentID: this.$route.query.id,
      };
      this.postRequest('/news-and-seminars/delete', data).then(() => {
        this.$router.push({ name: 'NewsAndSeminars', query: { show: this.show } });
      });
    },
    handleCancelClick() {
      this.$router.push({ name: 'NewsAndSeminars', query: { show: this.show } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
